import './AppLayoutFooter.css';

import React, { type FC } from 'react';

interface AppLayoutFooterProps {
  hardwareVersion: string
  machineMotionSoftwareVersion: string
  isPendantAvailable: boolean
  pendantSoftwareVersion: string
}

/**
 * Creates a Footer that displays the hardware and software versions.
 */
export const AppLayoutFooter: FC<AppLayoutFooterProps> = ({ hardwareVersion, machineMotionSoftwareVersion, isPendantAvailable, pendantSoftwareVersion }) => {
  const hardwareVersionNumber = formatHardwareVersion(hardwareVersion);

  return (
    <footer id="app-layout-footer">
      <span>{`MM: SW ${machineMotionSoftwareVersion}`}</span>
      <span>{` & HW ${hardwareVersionNumber} `}</span>
      {isPendantAvailable && <span>{`- Pendant: ${pendantSoftwareVersion}`}</span>}
    </footer>
  );
};

function formatHardwareVersion (hardwareVersion: string): string {
  const hardwareVersionParts = hardwareVersion.match(/V([0-9]+)([A-Z][0-9])(-1D)?/i);
  if (hardwareVersionParts === null) {
    return '';
  }

  const controllerVersion = `V${hardwareVersionParts[1]}`;
  const firmwareVersion = hardwareVersionParts[2];
  const oneDriveSuffix = hardwareVersionParts[3] !== undefined ? ' ONE-DRIVE' : '';

  return `${controllerVersion}${firmwareVersion}${oneDriveSuffix}`.toUpperCase();
}
